export default __webpack_public_path__ + "static/ms-startup-footer-5c5769257b3d418e6a309e8d85ff3b1e.png";